import { DanglingDossierDb } from "@/models/dangling-dossier-db";
import { Axios } from "./auth-service";


export class ServerDbService {
	public readonly url:string;

	public constructor(baseUrl:string) {
		this.url = `${baseUrl}/dbs`;
	}

	public async getDanglingDbs(dbId:number):Promise<DanglingDossierDb[]> {
		let result = await Axios.get(`${this.url}/dangling-dbs/${dbId}`);
		return (result.data || []).map((d:any)=>new DanglingDossierDb(d));
	}

	public async deleteDossierDb(dbId:number, dossierId:number):Promise<void>{
		await Axios.delete(`${this.url}/dossier-db/${dbId}/${dossierId}`);
	}
}